import { FC } from 'react';

import { ic_patient } from '.';

const PatientIcon: FC<{ width?: number }> = ({ width = 24 }) => {
  return <img src={ic_patient} width={width} alt="" />;
};

export default PatientIcon;
